module.exports = __webpack_public_path__ + "img/gl1.48637bc7.jpg";